import { render, staticRenderFns } from "./BakingFinishMetalPendant.vue?vue&type=template&id=d85b0a3a&scoped=true&"
import script from "./BakingFinishMetalPendant.vue?vue&type=script&lang=js&"
export * from "./BakingFinishMetalPendant.vue?vue&type=script&lang=js&"
import style0 from "./BakingFinishMetalPendant.vue?vue&type=style&index=0&id=d85b0a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85b0a3a",
  null
  
)

component.options.__file = "BakingFinishMetalPendant.vue"
export default component.exports